// Existing share endpoints enforce permission, expiry/revocation and album membership.
// Keep native downloads: no popup or in-memory ZIP/original buffering.
export function clientDownloadUrl(shareToken, image) {
  if (!shareToken) return null;
  const encodedToken = encodeURIComponent(shareToken);
  if (image) return image.filename ? `/media/share/original/${encodeURIComponent(image.filename)}?token=${encodedToken}&download=1` : null;
  return `/api/shares/public/${encodedToken}/download`;
}

export async function checkClientDownload({shareId, token, imageId, signal, fetchImpl = fetch}) {
  if (!shareId || !token) throw Object.assign(new Error('Please reopen the gallery and sign in again.'), {unavailable:true});
  const response = await fetchImpl(`/api/client/share/${encodeURIComponent(shareId)}/album`, {
    headers: {Authorization: `Bearer ${token}`}, cache: 'no-store', ...(signal ? {signal} : {})
  });
  if (!response.ok) {
    const unavailable = [401,403,404,410].includes(response.status);
    throw Object.assign(new Error(unavailable
      ? 'This gallery is no longer available for download. Please reopen it or contact the photographer.'
      : 'Unable to check download access. Please try again.'), {unavailable});
  }
  const data = await response.json();
  if (data.share?.allow_downloads !== true) throw Object.assign(new Error('Downloads are disabled for this gallery.'), {unavailable:true});
  if (!Array.isArray(data.images) || !data.images.length || (imageId && !data.images.some(image => image.id === imageId))) {
    throw new Error('This photo or album is no longer available to download. Please reload the gallery.');
  }
}

export function startClientDownload(url, documentImpl = document) {
  const link = documentImpl.createElement('a');
  link.href = url;
  link.download = '';
  documentImpl.body.appendChild(link);
  link.click();
  link.remove();
}
